import React from "react";
import { Box, Select, MenuItem, FormControl, ListItemText, InputLabel } from "@mui/material";

const SingleSelectDropdown = ({
  label = "",
  value = "",
  onChange = () => {},
  options = [],
  width = "",
  height = 45,
  sx={},
  background="#FFFFFF",
  color="#FFFFFF"
}) => {
  return (
    <Box width={width} sx={sx}>
      <FormControl fullWidth>
      <InputLabel sx={{ fontSize: "16px", color: "#6F6F6F", transform: value ? "translate(14px, -9px) scale(0.9)" : "translate(14px, 10px) scale(1)", "&.Mui-focused": { color: "#1D1D1D",transform: "translate(14px, -9px) scale(0.9)" }, }}>{label}</InputLabel>
        <Select
          value={value}
          label={label}
          onChange={(e) => onChange(e.target.value)}
          // displayEmpty
          renderValue={(selected) =>
            selected ? ( options.find((opt) => opt.value === selected)?.label || selected ) : ( <Box sx={{ color: "#000000" }}>{label}</Box> )}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 46 * 5.5,
                overflowY: "auto",
              },
            },
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "left",
            },
          }}
          sx={{
            height,
            background: background,
            color: background == "#FFFFFF" ? "inherit" : color,
            textAlign: "left",
            borderRadius: "10px",
            fontSize: 16,
            fontWeight: 500,
            outline: "none",
            "& .MuiOutlinedInput-root": {
              borderColor: "#C0C0C0",
              "&:hover fieldset": { borderColor: "#C0C0C0" },
              "&.Mui-focused fieldset": { borderColor: "#C0C0C0" },
            },
            "& .MuiSelect-icon": {
              color: "inherit",
            },
          }}
        >
          {options.map((item) => (
            <MenuItem key={item.value} value={item.value} sx={{ fontSize: 16, py: 0.5, gap: 1, }}>
              <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 16 }} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SingleSelectDropdown;
